import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GetRDSAlertsStatusQuery, RDSAlertsSortInput, RDSAlertsStatusFilter, RDSPaginationInput } from 'ngx-core-services';

const getAlertsFragment = `
  fragment rdsalertsstatustype on RDSAlertsStatusType {
    alerts {
      alertId
      alertName
      batteryModel
      deviceId
      status
      arm
      dspm
      dsps
      createdAt
      updatedAt
    }
    totalCount
  }
`;

@Injectable()
export class AlertRegistryService {

  constructor(private readonly getRDSAlertsStatusQuery: GetRDSAlertsStatusQuery) { }

  async getAlerts(
    pagination: RDSPaginationInput,
    filter?: RDSAlertsStatusFilter,
    sort?: RDSAlertsSortInput
  ) {
    const query = gql`${getAlertsFragment}`;
    const { data } = await this.getRDSAlertsStatusQuery.execute(
      query,
      {
        input: {
          pagination,
          filter,
          sort,
        },
      },
      true,
    );

    return data?.getRDSAlertsStatus;
  }
}